import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../../context/auth";
import { useSearchParams } from "react-router-dom";

const RequiredAuth = () => {
  const { accessToken } = useAuth();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  return accessToken ? (
    <Outlet />
  ) : (
    <Navigate
      to="/login/"
      state={{ from: location, redirectUrl: searchParams.get("redirectUrl") }}
      replace
    />
  );
};

export default RequiredAuth;
